





























import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { DepartmentFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class DepartmentFilter extends Mixins(ModelEditableMixin) {
  editingSource: DepartmentFilterParameter;

  get name(): StringFilterParameter {
    return this.editingSource.name;
  }

  set name(source: StringFilterParameter) {
    this.writeProperty(s => s.name = source);
  }

  get id(): StringFilterParameter {
    return this.editingSource.id;
  }

  set id(source: StringFilterParameter) {
    this.writeProperty(s => s.id = source);
  }

  clear(): void {
    this.writeProperty(s => s.clear());
  }
}
